import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'

import CustomerIdentification from './CustomerIdentification'
import { orderSelector } from '@/checkout-instore-legacy/order/selectors'
import { vendorSelector } from '@/checkout-instore-legacy/vendor/selectors'
import { actionCreators } from '@/checkout-instore-legacy/order/actions'

const mapStateToPropsSelector = createStructuredSelector({
  order: orderSelector,
  vendor: vendorSelector,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(
  mapStateToPropsSelector,
  mapDispatchToProps
)(CustomerIdentification)
